/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ businessName: NonNullable<unknown> }} Nowviewingbusiness2Inputs */

const en_nowviewingbusiness2 = /** @type {(inputs: Nowviewingbusiness2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Now viewing ${i?.businessName}`)
};

const de_nowviewingbusiness2 = /** @type {(inputs: Nowviewingbusiness2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.businessName} wird angezeigt`)
};

/**
* | output |
* | --- |
* | "Now viewing {businessName}" |
*
* @param {Nowviewingbusiness2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nowviewingbusiness2 = /** @type {((inputs: Nowviewingbusiness2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nowviewingbusiness2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nowviewingbusiness2(inputs)
	return de_nowviewingbusiness2(inputs)
});
export { nowviewingbusiness2 as "nowViewingBusiness" }